// extracted by mini-css-extract-plugin
export default {"toggle":"_3Kz3C","tooltip":"_3o3Tb","badge-icon":"_2iLGN","badgeIcon":"_2iLGN"};